import type { GeneralComponentClass } from 'webapp-types';

import InfolayerTypeGenieChatEndComponent from 'webapp/components/infolayer/type-genie-chat-end';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase from 'webapp/models-custom/infolayer-item/base';

export const MAX_TITLE_LENGTH = 30;

export interface ConstructorData extends BaseConstructorData {
	threadId: string;
	title: string | null;
	onOpen: (threadId: string) => void;
}

export default class InfolayerItemGenieChatEnd extends InfolayerItemBase {
	componentClass: GeneralComponentClass = InfolayerTypeGenieChatEndComponent;

	threadId: string;
	chatTitle: string | null;
	onOpen: (threadId: string) => void;

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.threadId = data.threadId;
		this.chatTitle = data.title;
		this.onOpen = data.onOpen;
	}

	get title(): string {
		return 'Your answer is ready';
	}

	get subtitle(): string {
		if (!this.chatTitle) {
			return 'Genie replied in your chat';
		}

		// Counted and cut by code points, so an emoji is never split into a broken half.
		const codePoints = Array.from(this.chatTitle);
		const shown =
			codePoints.length > MAX_TITLE_LENGTH
				? `${codePoints.slice(0, MAX_TITLE_LENGTH).join('').trimEnd()}…`
				: this.chatTitle;

		return `Genie replied in “${shown}” chat`;
	}

	open(): void {
		this.onOpen(this.threadId);
		this.close();
	}

	checkIfDuplicated(): boolean {
		return false;
	}
}
